export type TOptions = {
  year: string;
  months: TMonth[];
};

export type TMonth = TSelect;

export type TSelect = {
  label: string;
  value: string;
};

export enum EPeriodsStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export type IOptionsState = {
  options: TOptions[];
  status: EPeriodsStatus;
};
